import axios from 'axios'
import endpoints from '@/api/endpoints'


export default {
  async createSnowProject (snow) {
    return axios.post(endpoints.snowProjects, snow).then((response) => {
      return response.data
    })
  },
  async updateSnowProject (snow) {
    return axios.patch(endpoints.snowProjects + snow.id + '/', snow).then((response) => {
      return response.data
    })
  },
  async getSnowProjects () {
    return axios.get(endpoints.snowProjects).then((response) => {
      return response.data
    })
  }
}
